module.exports = __webpack_public_path__ + "img/head-side-medical.0d9a8057.svg";